<template>
    <div
        v-if="loading || categories.length > 0"
        class="bo-related-categories"
    >
        <div class="related-categories-title">
            {{ catalogTranslations.related_categories ?? "Related categories" }}
        </div>
        <div
            class="related-categories-list"
            :class="`count-${loading ? 2 : Math.min(categories.length, 3)}`"
        >
            <template v-if="loading">
                <div
                    v-for="n in 2"
                    :key="`related-skeleton-${n}`"
                    class="related-category search-skeleton"
                >
                    <div class="related-category-text">
                        <div class="skeleton-line short"></div>
                        <div class="skeleton-line"></div>
                    </div>
                </div>
            </template>
            <template v-else>
                <a
                    v-for="category in categories"
                    :key="category.id"
                    class="related-category"
                    :href="category.url"
                >
                    <div class="related-category-text">
                        <span class="count">{{ itemCountText(category.product_count) }}</span>
                        <span class="name">{{ category.name }}</span>
                    </div>
                </a>
            </template>
        </div>
    </div>
</template>

<script>
import httpMixin from "@/v2/mixins/http.js";

export default {
    mixins: [httpMixin],

    data() {
        const context = window.bo?.searchContext ?? null;

        return {
            context,
            // only when the Categories chip was on for this search
            enabled: !!context && (context.fields ?? []).includes("categories") && !!context.query,
            loading: false,
            categories: [],
            catalogTranslations: window.bo?.catalogTranslations ?? {},
        };
    },

    mounted() {
        if (!this.enabled) return;

        this.loading = true;
        // after the product list has painted, so it never waits for the category tree
        window.requestAnimationFrame(() => this.loadCategories());
    },

    methods: {

        loadCategories() {
            const params = {
                search: this.context.query,
                outletId: this.context.outletId,
                limit: 20,
            };
            if (this.context.categoryId) {
                params.categoryId = this.context.categoryId;
            }

            this.getData(
                this.context.categorySearchUrl,
                { params },
                (response) => {
                    this.categories = response.data?.data ?? [];
                    this.loading = false;
                },
                () => {
                    this.categories = [];
                    this.loading = false;
                },
                false
            );
        },

        itemCountText(count) {
            const template = this.catalogTranslations.items_count ?? ":count Items";

            return template.replace(":count", count ?? 0);
        },
    },
};
</script>
